import axios from 'axios'

// const instance = axios.create({
//   baseURL: process.env.API
// })

var processApi = process.env.API
const status = window.localStorage.getItem('envStatus')
if(status=='Live'){
  console.log("innnnn",processApi)
  processApi = 'https://liverunapi.npit.xyz/api'
}

const instance = axios.create({
  baseURL: processApi
})


instance.interceptors.request.use(config => {
  config.headers['Authorization'] = `Bearer ${window.localStorage.getItem('default-auth-token')}`
  config.headers['Accept'] = 'application/json'

  return config
}, error => {
  return Promise.reject(error)
})

export default instance



// WEBPACK FOOTER //
// ./src/api/index.js